exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".common-header{width:1400px;overflow:hidden;margin-left:auto;margin-right:auto}.common-header .el-tabs__header{margin:0!important}.common-header .el-tabs__item{padding:10px 150px 10px 50px;height:60px;font-size:16px;font-weight:600}.common-header .el-tabs__item .logo{display:block;float:left;padding:0 2px;width:32px;height:30px;margin-top:2px}.common-header .el-tabs__item .newfan{color:#007598;font-size:20px}.common-header .el-tabs__item .at{color:#888;font-size:16px;padding:2px 3px 5px 5px}.common-header .el-tabs__item .pinpai{color:#0f97ff;font-size:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09484026","scoped":false,"hasInlineConfig":false}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/header/index.vue
// module id = 156
// module chunks = 1